import React, { useState } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import home_logo from "../../assets/icons/ICRI_NEW1.png";
import MockService from "../../Services/MockService";

interface ILogin {
  counter: any
}

export default function Login({ counter }: ILogin) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email) {
      toast.error("Please enter your email");
      return;
    }
    setLoading(true);
    await MockService.checkEmailLogin(email)
      .then((res) => {
        if (res.status === 200) {
          toast.success("OTP sent to email");
          navigate('/verify', { state: { email } });
        }
      })
      .catch(() => toast.error("Something went wrong"))
      .finally(() => setLoading(false));
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <div className="auth-shell">
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div className="d-flex flex-column align-items-center mb-4">
          <img src={home_logo} alt="ICRI" style={{ height: 64, marginBottom: 16 }} />
          <h4 style={{ fontWeight: 700, color: '#1A1A2E', marginBottom: 4, textAlign: 'center' }}>
            MICR Mock Examination
          </h4>
          <p style={{ color: '#6C757D', fontSize: '0.875rem', margin: 0, textAlign: 'center' }}>
            Sign in to continue
          </p>
        </div>

        <div className="card-flat">
          <Form.Group className="mb-4">
            <Form.Label style={{ fontSize: '0.75rem', fontWeight: 600, color: '#6C757D', letterSpacing: '0.05em', textTransform: 'uppercase' }}>
              Email Address
            </Form.Label>
            <Form.Control
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={handleKeyDown}
              size="lg"
              style={{ fontSize: '0.9rem' }}
            />
          </Form.Group>

          <Button
            variant="primary"
            size="lg"
            className="w-100"
            onClick={handleLogin}
            disabled={loading}
            style={{ fontWeight: 600 }}
          >
            {loading ? <Spinner animation="border" size="sm" className="me-2" /> : null}
            {loading ? 'Sending OTP\u2026' : 'Continue'}
          </Button>
        </div>
      </div>
    </div>
  );
}
